import { Translation } from 'react-i18next';
import React, { useCallback, useState } from 'react';

import { SelectTab } from '@/components';
import { wrapModalPromise } from '@/utils';

import { SpamReportModal, SpamReportModalProp } from './SpamReport';
import { RestrictionRecords, RestrictionRecordsProps } from './RestrictionRecords';
import style from './index.module.scss';

const TABS = [
  {
    mode: 'spam',
    label: <Translation>{t => t('UserDeal.1b8izd4')}</Translation>,
  },
  {
    mode: 'restriction',
    label: <Translation>{t => t('UserDeal.155jz5a')}</Translation>,
  },
];

type Props = {
  isRestricted?: boolean;
} & SpamReportModalProp &
  RestrictionRecordsProps;

const UserDeal = ({ isRestricted, address, refetchCallback }: Props) => {
  const [type, setType] = useState(isRestricted ? TABS[1].mode : TABS[0].mode);

  const handleTabChange = useCallback((mode: string) => {
    setType(mode);
  }, []);

  return (
    <div className={style.container}>
      <SelectTab
        value={type}
        options={TABS}
        onChange={handleTabChange}
        className={style.selectTabs}
        itemClassName={style.selectTabItem}
        bottomBorder
      />
      {type === TABS[0].mode ? (
        <SpamReportModal address={address} refetchCallback={refetchCallback} />
      ) : null}
      {type === TABS[1].mode ? <RestrictionRecords address={address} /> : null}
    </div>
  );
};

export const openUserDealModal = wrapModalPromise<Props, void>(UserDeal, {
  containerClassName: style.modal,
  size: 'medium',
});

export { useUserRestricted } from './RestrictionRecords/hooks';
